import React, { useEffect } from 'react';
import firebase from "firebase/app";
import { useHistory } from 'react-router-dom';
import logo from './../rcrm_logo.png';
import './../App.css';
import Button from '@material-ui/core/Button';
require('dotenv').config();

const MainPage = () => {
  useEffect(() => {
    firebase.auth().signOut().then(() => {
      localStorage.clear();
      sessionStorage.clear();
      // window.location.href = '/';
  }).catch((error) => {
  });
    localStorage.clear();
    sessionStorage.clear();
  });
  if (document.addEventListener) {
    document.addEventListener('contextmenu', function (e) {
      e.preventDefault();
    }, false);
  }
  const history = useHistory();

  function handleClick() {
    if(typeof process !== 'undefined' && process && process.env && process.env.REACT_APP_LOAD_TESTING == 1){
      localStorage.clear();
      sessionStorage.clear();
              history.push("/login");
    }else{
      localStorage.clear();
      sessionStorage.clear();
      history.push("/login");
    }
  }

  function handleClickAdmin() {
    history.push("/createexam");
  }
  // function logout() {
  //   firebase.auth().signOut().then(() => {
  //       localStorage.clear();
  //       window.location.href = '/';
  //   }).catch((error) => {
  //   });
  // }

  return (
    <div className="App">
      <div className="App-header">
        <img src={logo} alt="logo" className="App-logo" />
        <h1 style={{ color: '#004085', marginBottom: '20px' }} id="welcomeTxt">Welcome to RecruitCRM Professional Assessment Platform</h1>
        <Button id="homeButtons" variant="contained" onClick={handleClick}>
          Begin Assessment
        </Button>
        {/* <Button id="homeButtons" variant="contained" onClick={handleClickAdmin}>
          Admin
        </Button> */}
        {/* <Button 
            variant="contained" 
            className="menu-button logout-button" 
            onClick={logout} 
            style={{ backgroundColor: '#dc3545', color: 'white', padding: '7px 10px', marginLeft: '20px' }} // Red
          >
            Log Out
          </Button> */}
      </div>
    </div>
  );
}

export default MainPage;
